var map = {
	"./icon-admin.svg": 78033,
	"./icon-bianji.svg": 56193,
	"./icon-config.svg": 54886,
	"./icon-dangdifill.svg": 10122,
	"./icon-daohang.svg": 53844,
	"./icon-duanxin.svg": 22169,
	"./icon-editor.svg": 84559,
	"./icon-geren.svg": 30899,
	"./icon-jiesuo.svg": 80879,
	"./icon-job.svg": 41821,
	"./icon-log.svg": 35834,
	"./icon-menu.svg": 51601,
	"./icon-mudedi.svg": 23610,
	"./icon-oss.svg": 62709,
	"./icon-pinglun.svg": 61545,
	"./icon-role.svg": 26180,
	"./icon-shanchu.svg": 24490,
	"./icon-shezhi.svg": 40301,
	"./icon-shoucang.svg": 86572,
	"./icon-shoucangfill.svg": 71887,
	"./icon-shouye.svg": 19327,
	"./icon-sousuo.svg": 59446,
	"./icon-sql.svg": 39064,
	"./icon-suoding.svg": 63087,
	"./icon-system.svg": 90479,
	"./icon-tixing.svg": 36653,
	"./icon-tubiao.svg": 94766,
	"./icon-xiangqu.svg": 59981,
	"./icon-xiangqufill.svg": 72962,
	"./icon-zhedie.svg": 11663,
	"./icon-zonghe.svg": 4049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71525;